import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { t } from "../utils/i18n";
import PageMeta from "../components/PageMeta";
import CreateVenueModal from "../components/CreateVenueModal";

// Landing publique "Créer ma page gratuitement" — porte d'entrée légère vers le dashboard Pro/
// Association déjà construit (Membres, check-in QR, fidélité, gestion d'événements), pensée pour
// un visiteur qui ne connaît pas encore OLTODO (accessible sans compte, voir App.tsx : seule route
// avec les pages légales à rester joignable quand !token). Le CTA ouvre directement
// CreateVenueModal pour un visiteur déjà connecté ; sinon il passe par l'inscription puis revient
// ici automatiquement (paramètre `redirect`, voir RedirectToLogin dans App.tsx) pour l'ouvrir.
const FEATURES: { titleKey: string; bodyKey: string; icon: string }[] = [
  { titleKey: "pro_landing_feature_members_title", bodyKey: "pro_landing_feature_members_body", icon: "👥" },
  { titleKey: "pro_landing_feature_checkin_title", bodyKey: "pro_landing_feature_checkin_body", icon: "📷" },
  { titleKey: "pro_landing_feature_events_title", bodyKey: "pro_landing_feature_events_body", icon: "📅" },
];

export default function Pro() {
  const { lang, token } = useApp();
  const navigate = useNavigate();
  const [showCreate, setShowCreate] = useState(false);

  const handleCta = () => {
    if (token) setShowCreate(true);
    else navigate(`/register?redirect=${encodeURIComponent("/pro?openCreate=1")}`);
  };

  // Retour d'inscription : ouvre directement le modal plutôt que de refaire cliquer le CTA.
  React.useEffect(() => {
    if (token && new URLSearchParams(window.location.search).get("openCreate") === "1") {
      setShowCreate(true);
    }
  }, [token]);

  return (
    <>
      <PageMeta title={t(lang, "pro_landing_title")} description={t(lang, "pro_landing_subtitle")} />
      <div style={{ height: "100%", overflowY: "auto", WebkitOverflowScrolling: "touch", backgroundColor: "#F5F5F5" }}>
        <div style={{ maxWidth: 560, margin: "0 auto", padding: "48px 20px 80px" }}>
          <div style={{ textAlign: "center", marginBottom: 40 }}>
            <div style={{ fontSize: 15, fontWeight: 800, letterSpacing: 1, color: "#999", marginBottom: 12 }}>OLTODO PRO</div>
            <h1 style={{ fontSize: 30, fontWeight: 800, margin: "0 0 12px", lineHeight: 1.2 }}>{t(lang, "pro_landing_title")}</h1>
            <p style={{ fontSize: 16, color: "#666", lineHeight: 1.5, margin: 0 }}>{t(lang, "pro_landing_subtitle")}</p>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 14, marginBottom: 36 }}>
            {FEATURES.map(f => (
              <div key={f.titleKey} style={{ display: "flex", gap: 16, alignItems: "flex-start", backgroundColor: "white", borderRadius: 16, padding: 18, border: "1px solid #EEE" }}>
                <div style={{ fontSize: 26, flexShrink: 0 }}>{f.icon}</div>
                <div>
                  <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 4 }}>{t(lang, f.titleKey)}</div>
                  <div style={{ fontSize: 13.5, color: "#666", lineHeight: 1.5 }}>{t(lang, f.bodyKey)}</div>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={handleCta}
            style={{ width: "100%", padding: "16px", borderRadius: 14, border: "none", backgroundColor: "#0a0a0a", color: "white", fontSize: 15, fontWeight: 700, cursor: "pointer" }}
          >
            {t(lang, "pro_landing_cta")}
          </button>

          {!token && (
            <div style={{ textAlign: "center", marginTop: 18, fontSize: 13.5, color: "#999" }}>
              {t(lang, "pro_landing_already_have")}{" "}
              <span onClick={() => navigate(`/login?redirect=${encodeURIComponent("/pro?openCreate=1")}`)} style={{ color: "#0a0a0a", fontWeight: 700, cursor: "pointer", textDecoration: "underline" }}>
                {t(lang, "pro_landing_login_link")}
              </span>
            </div>
          )}
        </div>
      </div>

      {showCreate && (
        <CreateVenueModal
          onClose={() => setShowCreate(false)}
          defaultSubtype="pro"
          forceOwner
          onCreated={(venue) => { setShowCreate(false); if (venue?.id) navigate(`/venue/${venue.id}`); }}
        />
      )}
    </>
  );
}
